import React, { forwardRef } from 'react';
import Modal, {
  ModalProps,
  ModalRef,
} from '@/components/@IntranetLibrary/Modal';
import OutlookContents from '@/components/Record/OutlookButton/OutlookModal/OutlookContents';
import { useTranslation } from 'react-i18next';
import usePlatform from '@/components/Record/hooks/usePlatform';

type OutlookModalProps = Pick<ModalProps, 'handleClose'>;

const OutlookModal = forwardRef<ModalRef, OutlookModalProps>((props, ref) => {
  const { isMobilePath } = usePlatform();
  const { t } = useTranslation();
  const { handleClose } = props;

  return (
    <Modal
      ref={ref}
      title={t('Outlook 일정 선택')}
      availableAutoClose={false}
      handleClose={handleClose}
      size={isMobilePath ? 'expand' : 'small'}
      sx={{
        '.modal-footer': { padding: '12px 12px 12px 20px' },
        '.modal-inner': {
          minWidth: isMobilePath ? '0' : '',
        },
      }}
    >
      <OutlookContents handleClose={handleClose} />
    </Modal>
  );
});
OutlookModal.displayName = 'OutlookModal';

export default OutlookModal;
